import {Injectable} from '@angular/core';

/**
 * Translations for customer score.
 */
@Injectable()
export class CustomerScoreTranslationsService {
  public i18nPurchased: any = $localize`:@@general.status.purchased:Purchased`;
  public i18nActivity: any = $localize`:@@general.status.activity:Activity`;
  public i18nTicketQuantity: any = $localize`:@@general.status.ticketQuantity:Ticket-Quantity`;
  public i18nTicketRevenue: any = $localize`:@@general.status.ticketRevenue:Ticket-Revenue`;
  public i18nMerchQuantity: any = $localize`:@@general.status.merchQuantity:Merch-Quantity`;
  public i18nMerchRevenue: any = $localize`:@@general.status.merchRevenue:Merch-Revenue`;
  public i18MonthsTimeFrame: any = $localize`:@@general.status.monthsTimeFrame:Time frame (months)`;
  constructor() { }
}
